import { render, staticRenderFns } from "./CustomOptions.vue?vue&type=template&id=3de385c6&scoped=true&"
import script from "./CustomOptions.vue?vue&type=script&lang=ts&"
export * from "./CustomOptions.vue?vue&type=script&lang=ts&"
import style0 from "./CustomOptions.vue?vue&type=style&index=0&id=3de385c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de385c6",
  null
  
)

export default component.exports